import axios from "axios";
import { getAuthToken } from "./authToken";

let registered = false;

/**
 * Registers a request interceptor on the default axios instance (used by every Cin7 endpoint)
 * that attaches the bearer token. Idempotent. RTK Query attaches it separately in apiSlice.
 */
export const registerAuthInterceptor = (): void => {
  if (registered) {
    return;
  }
  registered = true;
  axios.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    return config;
  });
};
